import Component from '@glimmer/component';
import Icon from 'madow-tech/components/icon';

interface SpaceBadgeSignature {
  Args: {
    variant?: 'tech' | 'skill' | 'status' | 'level';
    icon?: string;
    size?: 'sm' | 'md' | 'lg';
    glow?: boolean;
    text: string;
    autoIcon?: boolean;
  };
}

export default class SpaceBadge extends Component<SpaceBadgeSignature> {
  get badgeClass() {
    const variant = this.args.variant || 'tech';
    const size = this.args.size || 'sm';
    const glow = this.args.glow ? 'space-badge--glow' : '';

    return `space-badge space-badge--${variant} space-badge--${size} ${glow}`.trim();
  }

  get iconName() {
    if (this.args.icon) {
      return this.args.icon;
    }

    if (this.args.autoIcon && this.args.variant === 'tech') {
      const techIcons: Record<string, string> = {
        TypeScript: 'svg-cpu',
        JavaScript: 'svg-cpu',
        Ember: 'svg-flame',
        React: 'svg-cpu',
        NestJS: 'svg-workflow',
        Node: 'svg-workflow',
        APIs: 'svg-cloud',
        DevOps: 'svg-workflow',
        UI: 'svg-brush',
        SQL: 'svg-workflow',
        Postgres: 'svg-workflow',
        Figma: 'svg-brush',
        Tailwind: 'svg-brush',
        Prototyping: 'svg-wrench',
        'Technical PM': 'svg-users',
        Tickets: 'svg-wrench',
        Sprints: 'svg-clock',
      };

      return techIcons[this.args.text] || 'svg-star';
    }

    return this.args.variant === 'tech' ? 'svg-cpu' : 'svg-star';
  }

  <template>
    <div class='space-badge-wrapper'>
      <span class={{this.badgeClass}} ...attributes>
        <Icon @name={{this.iconName}} @svgClass="space-badge__icon" />
        <span class="space-badge__text">{{@text}}</span>
      </span>
    </div>
  </template>
}
